(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/sportkryss.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/sportkryss.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.tipset.views.Sportkryss = Backbone.Marionette.View.extend({
    modelEvents: {
      change: 'render'
    },

    regions: {
      sportkryss: '#betslipSportkryss'
    },

    template: function(data) {
      return svs.tipset.templates.sportkryss(data);
    },

    initialize: function() {
      var self = this;
      var sportkryssOptions = {
        onSportkryssChanged: function(
          sportkryssBet,
          isValid,
          sportkryssNumber
        ) {
          self.model.handleOnSportkryssChange(
            sportkryssBet,
            isValid,
            sportkryssNumber
          );
        },
        model: this.model.get('sportkryssBet'),
        toggleButtonCSSClass: 'btn-toggle-betslip-stryktipset',
        defaultSportkryssAmount: this.model.get('defaultSportkryssAmount'),
        sportkryssNumber: this.model.get('sportkryssNr'),
        helpDialogTitle: svs.tipset.data.config.helpTexts ?
            svs.tipset.data.config.helpTexts.sportkryss.title :
            null,
        helpDialogBody: svs.tipset.data.config.helpTexts ?
            svs.tipset.data.config.helpTexts.sportkryss.body :
            null
      };
      this.sportkryssView = new svs.sport.sportkryss.Sportkryss(sportkryssOptions);
    },

    onRender: function() {
      this.getRegion('sportkryss').show(this.sportkryssView);
    },

    handleOnSportkryssChange: function(
      sportkryssBet,
      isValid,
      sportkryssNumber
    ) {
      this.model.handleOnSportkryssChange(
        sportkryssBet,
        isValid,
        sportkryssNumber
      );
    }
  });
})(Backbone, _, svs);

 })(window);